/**
 * Извлича името на ресторанта от hostname
 *
 * Логика:
 * - Ако сме на localhost/127.0.0.1 -> VITE_RESTAURANT_NAME (или "central")
 * - Иначе взима първата част от hostname преди първата точка
 * - Например: soft3-rest1.unrealsoft.cloud -> soft3-rest1
 */
export function getRestaurantName(): string {
  const hostname = window.location.hostname;

  // localhost ИЛИ голо IP (тест от телефон в локалната мрежа през
  // vite --host) — иначе split(".")[0] от IP-то би дало ресторант „172"
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  ) {
    // ЛОКАЛНО САМО: ресторантът трябва да съществува в org базата, към
    // която сочи локалното BE — затова идва от .env, а не от кода.
    // На прод ресторантът винаги идва от поддомейна.
    return import.meta.env.VITE_RESTAURANT_NAME || "central";
  }

  return hostname.split(".")[0];
}
